var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 39.998,
    viewBox: "0 0 40 39.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down-arrow",
    transform: "translate(-1.001 42.251) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    width: 39.998,
    height: 40,
    rx: 8,
    transform: "translate(2.253 1.001)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(17.753 14.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-2",
    "data-name": "arrow",
    d: "M279,768a1,1,0,0,1-.706-1.7l4.8-4.8-4.8-4.8a1,1,0,0,1,1.412-1.412l5.5,5.5a1,1,0,0,1,0,1.412l-5.5,5.5A1,1,0,0,1,279,768Z",
    transform: "translate(-277.999 -755)",
    fill: "#09c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.35f02b7c6486be3ad260a069a08c6747.svg";
export { ForwardRef as ReactComponent };